import React, { Component } from 'react';
import { OrderSummaryListing } from './Listings/OrderSummaryListing';


export class OrderList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            orderData: [],
            loading: true,
            supplierFilterId: 'all',
            searchTerm: ''
        };
        this.handleSupplierFilterChange = this.handleSupplierFilterChange.bind(this);
        this.handleSearchChange = this.handleSearchChange.bind(this);
        this.populateOrderList = this.populateOrderList.bind(this);
    }

    static defaultProps = {
        itemListingId: 0,
    }

    componentDidMount() {
        this.populateOrderList();
    }

    handleSupplierFilterChange(event) {
        this.setState({ supplierFilterId: event.target.value });
    }

    handleSearchChange(event) {
        this.setState({ searchTerm: event.target.value });
    }

    getUniqueSuppliers(orders) {
        const map = new Map();
        for (const o of orders) {
            const s = o.orderDetails?.supplier;
            if (s && !map.has(s.id)) {
                map.set(s.id, s);
            }
        }
        return Array.from(map.values());
    }

    applyFilters(orders) {
        const { supplierFilterId, searchTerm } = this.state;
        const term = (searchTerm || '').toLowerCase().trim();

        let filtered = orders;

        // Supplier filter
        if (supplierFilterId !== 'all') {
            const id = Number(supplierFilterId);
            filtered = filtered.filter(o => o.orderDetails?.supplier?.id === id);
        }

        // Search by ItemListing.Name or ManufacturerModelNumber
        if (term.length > 0) {
            filtered = filtered.filter(o => {
                const name = (o.itemListing?.name || '').toLowerCase();
                const mpn = (o.orderDetails?.manufacturerModelNumber || '').toLowerCase();
                return name.includes(term) || mpn.includes(term);
            });
        }

        // Sort by EstimatedArrivalDate (soonest first), then Supplier name, then Item name
        filtered = filtered.slice().sort((a, b) => {
            const ad = new Date(a.estimatedArrivalDate).getTime();
            const bd = new Date(b.estimatedArrivalDate).getTime();
            if (ad !== bd) return ad - bd;
            const as = (a.orderDetails?.supplier?.name || '').localeCompare(b.orderDetails?.supplier?.name || '');
            if (as !== 0) return as;
            return (a.itemListing?.name || '').localeCompare(b.itemListing?.name || '');
        });

        return filtered;
    }

    renderFilters() {
        const suppliers = this.getUniqueSuppliers(this.state.orderData);
        return (
            <div style={{ display: "flex", gap: "10px", alignItems: "center", marginBottom: "10px", flexWrap: "wrap" }}>
                <div>
                    <label htmlFor="supplierFilter" style={{ marginRight: "6px" }}>Supplier</label>
                    <select id="supplierFilter" className="form-select" style={{ minWidth: "220px", display: "inline-block" }}
                        value={this.state.supplierFilterId}
                        onChange={this.handleSupplierFilterChange}>
                        <option value="all">All suppliers</option>
                        {suppliers.map(s => (
                            <option key={s.id} value={s.id}>{s.name}</option>
                        ))}
                    </select>
                </div>

                <div>
                    <label htmlFor="orderSearch" style={{ marginRight: "6px" }}>Search</label>
                    <input
                        id="orderSearch"
                        type="text"
                        className="form-control"
                        placeholder="Item name or manufacturer part number"
                        value={this.state.searchTerm}
                        onChange={this.handleSearchChange}
                        style={{ minWidth: "320px", display: "inline-block" }}
                    />
                </div>

                <div style={{ marginLeft: "auto" }}>
                    <span className="badge bg-secondary">Total: {this.state.orderData.length}</span>&nbsp;
                    <span className="badge bg-primary">Filtered: {this.applyFilters(this.state.orderData).length}</span>
                </div>
            </div>
        );
    }

    renderOrderList(orderData) {
        const filtered = this.applyFilters(orderData);
        return (
            <div id="flex-container">
                {filtered.map(orderData => <OrderSummaryListing key={orderData.id} orderData={orderData} />)}
            </div>
        );
    }

    render() {
        let contents;
        if (this.state.loading) {
            contents = <p><em>Loading...</em></p>;
        } else {
            contents = (this.state.orderData.length > 0)
                ? this.renderOrderList(this.state.orderData)
                : <p>No orders found</p>;
        }

        return (
            <div style={{ padding: "10px" }}>
                <h3>Placed Orders</h3>
                {this.renderFilters()}
                {contents}
            </div>
        );
    }

    async populateOrderList() {
        if (this.props.itemListingId === 0) {
            const response = await fetch(`api/ordering/list-open-orders`);
            const data = await response.json();
            this.setState({ orderData: data || [], loading: false });
        }
        else {
            const response = await fetch(`api/ordering/list-item-orders?itemListingId=${this.props.itemListingId}`);
            const data = await response.json();
            this.setState({ orderData: data || [], loading: false });
        }
    }
}